import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

export interface Trade {
  base_token_amount: number;
  base_token_price_usd: number;
  block_num: number;
  block_timestamp: number;
  chain_id: number;
  maker: string;
  pair_address: string;
  swap_name: string;
  to: string;
  token_address: string;
  token_amount: number;
  token_price_usd: number;
  total_usd: number;
  trade_type: number;
  tx_hash: string;
}

export interface WsTokenState {
  block_num: number;
  chain_id: number;
  change_24: string;
  change_1m: string;
  change_1h: string;
  change_5m: string;
  mkt_cap: string;
  token_address: string;
  token_price: string;
  trades: Trade[];
  txs_24h: number;
  vol_24h: string;
}

const initialState: Partial<WsTokenState> = {
  block_num: undefined,
  chain_id: undefined,
  change_24: undefined,
  mkt_cap: undefined,
  token_address: undefined,
  token_price: undefined,
  trades: [],
  txs_24h: undefined,
  vol_24h: undefined,
};

export const wsTokenSlice = createSlice({
  name: 'wsToken',
  initialState,
  reducers: {
    updateWsToken: (state, action: PayloadAction<WsTokenState>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    clearWsToken: (state) => {
      return initialState;
    },
  },
});

// 导出 actions
export const { updateWsToken, clearWsToken } = wsTokenSlice.actions;

// 导出 selectors
export const selectWsToken = (state: RootState) => state.wsToken;
export const selectTokenPrice = (state: RootState) => state.wsToken.token_price;
export const selectMarketCap = (state: RootState) => state.wsToken.mkt_cap;
export const selectChange24h = (state: RootState) => state.wsToken.change_24;
export const selectVolume24h = (state: RootState) => state.wsToken.vol_24h;
export const selectTrades = (state: RootState) => state.wsToken.trades;

export const selectWsTokenByAddress =
  (token_address: string) => (state: RootState) =>
    state.wsToken.token_address === token_address ? state.wsToken : null;

export default wsTokenSlice.reducer;
